export const product_metafield_identifiers = [
    { namespace: 'addon', key: 'products' },
    { namespace: 'addon', key: 'title' },
    { namespace: 'global', key: 'preorder_date' },
    { namespace: 'accordion', key: 'item_3_title' },
    { namespace: 'accordion', key: 'item_3_description' },
    { namespace: 'accordion', key: 'item_4_title' },
    { namespace: 'accordion', key: 'item_4_description' },
    { namespace: 'marketplace', key: 'message' },
    { namespace: 'accordion', key: 'item_2_title' },
    { namespace: 'accordion', key: 'item_1_title' },
    { namespace: 'accordion', key: 'item_1_description' },
    { namespace: 'accordion', key: 'item_2_description' },
    { namespace: 'eyebrow', key: 'message' },
    { namespace: 'subtitle', key: 'message' },
    { namespace: 'reviews', key: 'rating_count' },
    { namespace: 'reviews', key: 'rating' },
    { namespace: 'accordion', key: 'Alt-image-1' },
    { namespace: 'accordion', key: 'Alt-image-2' },
    { namespace: 'accordion', key: 'Alt-image-3' },
    { namespace: 'accordion', key: 'Alt-image-4' },
    { namespace: 'accordion', key: 'Anti-Tip-Kit' },
    { namespace: 'accordion', key: 'Art/Print/Frame Dimensions' },
    { namespace: 'accordion', key: 'available_locations' },
    { namespace: 'accordion', key: 'Bed/Headboard Size' },
    { namespace: 'accordion', key: 'Bedding-Size' },
    { namespace: 'accordion', key: 'Brand' },
    { namespace: 'accordion', key: 'Category' },
    { namespace: 'accordion', key: 'country_of_manufacture' },
    { namespace: 'accordion', key: 'data' },
    { namespace: 'accordion', key: 'dimension' },
    { namespace: 'accordion', key: 'expert_tips' },
    { namespace: 'accordion', key: 'Family-Color' },
    { namespace: 'accordion', key: 'General-Size' },
    { namespace: 'accordion', key: 'image_text_1' },
    { namespace: 'accordion', key: 'image_text_2' },
    { namespace: 'accordion', key: 'image_text_3' },
    { namespace: 'accordion', key: 'image_text_4' },
    { namespace: 'accordion', key: 'image_text_5' },
    { namespace: 'accordion', key: 'Main-Image' },
    { namespace: 'accordion', key: 'manufacturer' },
    { namespace: 'accordion', key: 'material' },
    { namespace: 'accordion', key: 'Oversized-Item' },
    { namespace: 'accordion', key: 'Pillow Dimensions' },
    { namespace: 'accordion', key: 'position' },
    { namespace: 'accordion', key: 'Product-Name' },
    { namespace: 'accordion', key: 'Prop-65' },
    { namespace: 'accordion', key: 'retail-price' },
    { namespace: 'accordion', key: 'Returnable' },
    { namespace: 'accordion', key: 'return_policy' },
    { namespace: 'accordion', key: 'Rug Dimensions' },
    { namespace: 'accordion', key: 'Shipping Policy' },
    { namespace: 'accordion', key: 'shopify2_product_id' },
    { namespace: 'accordion', key: 'shopify_product_id' },
    { namespace: 'accordion', key: 'Short-Description' },
    { namespace: 'accordion', key: 'Size-Chart-Image' },
    { namespace: 'accordion', key: 'Specific-Color-Name' },
    { namespace: 'accordion', key: 'Swatch-Image' },
    { namespace: 'accordion', key: 'tags' },
    { namespace: 'accordion', key: 'UPC' },
    { namespace: 'accordion', key: 'Variant-Group-Code' },
    { namespace: 'accordion', key: 'Variant-Type' },
    { namespace: 'accordion', key: 'weight' },
    { namespace: 'global', key: 'title_' },
    { namespace: 'google', key: 'custom_label_0' },
    { namespace: 'google', key: 'google_product_type' },
    { namespace: 'info', key: 'shop_id' },
    { namespace: 'mm-google-shopping', key: 'custom_label_0' },
    { namespace: 'mm-google-shopping', key: 'custom_product' },
    { namespace: 'okendo', key: 'ProductListingSnippet' },
    { namespace: 'okendo', key: 'ProductReviewsWidgetSnippet' },
    { namespace: 'okendo', key: 'ReviewsWidgetSnippet' },
    { namespace: 'okendo', key: 'StarRatingSnippet' },
    { namespace: 'okendo', key: 'summaryData' }
]

export const variant_metafield_identifiers = [
    { namespace: 'global', key: 'non_standard_ship_by_message' },
    { namespace: 'global', key: 'exclude_preorder' },
    { namespace: 'global', key: 'preorder_date' },
    { namespace: 'eyebrow', key: 'message' },
    { namespace: 'accordian', key: 'Alt-image-1' },
    { namespace: 'accordian', key: 'Alt-image-2' },
    { namespace: 'accordian', key: 'Anti-Tip-Kit' },
    { namespace: 'accordian', key: 'Brand Name' },
    { namespace: 'accordian', key: 'care' },
    { namespace: 'accordian', key: 'Category' },
    { namespace: 'accordian', key: 'country_of_manufacture' },
    { namespace: 'accordian', key: 'data' },
    { namespace: 'accordian', key: 'dimension' },
    { namespace: 'accordian', key: 'expert_tips' },
    { namespace: 'accordian', key: 'Family-Color' },
    { namespace: 'accordian', key: 'image_text_1' },
    { namespace: 'accordian', key: 'Main-Image' },
    { namespace: 'accordian', key: 'manufacturer' },
    { namespace: 'accordian', key: 'material' },
    { namespace: 'accordian', key: 'Pillow Dimensions' },
    { namespace: 'accordian', key: 'Product-Name' },
    { namespace: 'accordian', key: 'Prop-65' },
    { namespace: 'accordian', key: 'Returnable' },
    { namespace: 'accordian', key: 'return_policy' },
    { namespace: 'accordian', key: 'Shipping Policy' },
    { namespace: 'accordian', key: 'shopify_product_id' },
    { namespace: 'accordian', key: 'Short-Description' },
    { namespace: 'accordian', key: 'Specific-Color-Name' },
    { namespace: 'accordian', key: 'Swatch-Image' },
    { namespace: 'accordian', key: 'tags' },
    { namespace: 'accordian', key: 'UPC' },
    { namespace: 'accordian', key: 'Variant-Group-Code' },
    { namespace: 'accordian', key: 'Variant-Type' },
    { namespace: 'accordian', key: 'weight' },
    { namespace: 'accordion', key: 'Alt-image-1' },
    { namespace: 'accordion', key: 'Alt-image-2' },
    { namespace: 'accordion', key: 'Alt-image-3' },
    { namespace: 'accordion', key: 'Alt-image-4' },
    { namespace: 'accordion', key: 'Anti-Tip-Kit' },
    { namespace: 'accordion', key: 'Art/Print/Frame Dimensions' },
    { namespace: 'accordion', key: 'Bed/Headboard Size' },
    { namespace: 'accordion', key: 'Bedding-Size' },
    { namespace: 'accordion', key: 'Brand' },
    { namespace: 'accordion', key: 'Brand Name' },
    { namespace: 'accordion', key: 'care' },
    { namespace: 'accordion', key: 'Category' },
    { namespace: 'accordion', key: 'country_of_manufacture' },
    { namespace: 'accordion', key: 'data' },
    { namespace: 'accordion', key: 'dimension' },
    { namespace: 'accordion', key: 'expert_tips' },
    { namespace: 'accordion', key: 'Family-Color' },
    { namespace: 'accordion', key: 'General-Size' },
    { namespace: 'accordion', key: 'image_text_1' },
    { namespace: 'accordion', key: 'image_text_2' },
    { namespace: 'accordion', key: 'image_text_3' },
    { namespace: 'accordion', key: 'image_text_4' },
    { namespace: 'accordion', key: 'image_text_5' },
    { namespace: 'accordion', key: 'item_1_description' },
    { namespace: 'accordion', key: 'item_2_description' },
    { namespace: 'accordion', key: 'item_3_description' },
    { namespace: 'accordion', key: 'Main-Image' },
    { namespace: 'accordion', key: 'manufacturer' },
    { namespace: 'accordion', key: 'material' },
    { namespace: 'accordion', key: 'Oversized-Item' },
    { namespace: 'accordion', key: 'Pillow Dimensions' },
    { namespace: 'accordion', key: 'position' },
    { namespace: 'accordion', key: 'Product-Name' },
    { namespace: 'accordion', key: 'Prop-65' },
    { namespace: 'accordion', key: 'retail-price' },
    { namespace: 'accordion', key: 'Returnable' },
    { namespace: 'accordion', key: 'return_policy' },
    { namespace: 'accordion', key: 'Rug Dimensions' },
    { namespace: 'accordion', key: 'Shipping Policy' },
    { namespace: 'accordion', key: 'shopify2_product_id' },
    { namespace: 'accordion', key: 'shopify_product_id' },
    { namespace: 'accordion', key: 'Short-Description' },
    { namespace: 'accordion', key: 'Size-Chart-Image' },
    { namespace: 'accordion', key: 'Specific-Color-Name' },
    { namespace: 'accordion', key: 'Swatch-Image' },
    { namespace: 'accordion', key: 'tags' },
    { namespace: 'accordion', key: 'UPC' },
    { namespace: 'accordion', key: 'Variant-Group-Code' },
    { namespace: 'accordion', key: 'Variant-Type' },
    { namespace: 'accordion', key: 'weight' },
    { namespace: 'info', key: 'offerId' },
    { namespace: 'info', key: 'shop_id' },
    { namespace: 'info', key: 'shop_name' },
    { namespace: 'mirakl', key: 'Alt-image-1' },
    { namespace: 'mirakl', key: 'Alt-image-2' },
    { namespace: 'mirakl', key: 'Anti-Tip-Kit' },
    { namespace: 'mirakl', key: 'Art/Print/Frame Dimensions' },
    { namespace: 'mirakl', key: 'Brand Name' },
    { namespace: 'mirakl', key: 'care' },
    { namespace: 'mirakl', key: 'Category' },
    { namespace: 'mirakl', key: 'country_of_manufacture' },
    { namespace: 'mirakl', key: 'data' },
    { namespace: 'mirakl', key: 'dimension' },
    { namespace: 'mirakl', key: 'expert_tips' },
    { namespace: 'mirakl', key: 'Family-Color' },
    { namespace: 'mirakl', key: 'image_text_1' },
    { namespace: 'mirakl', key: 'Main-Image' },
    { namespace: 'mirakl', key: 'manufacturer' },
    { namespace: 'mirakl', key: 'material' },
    { namespace: 'mirakl', key: 'Pillow Dimensions' },
    { namespace: 'mirakl', key: 'Product-Name' },
    { namespace: 'mirakl', key: 'Prop-65' },
    { namespace: 'mirakl', key: 'retail-price' },
    { namespace: 'mirakl', key: 'Returnable' },
    { namespace: 'mirakl', key: 'return_policy' },
    { namespace: 'mirakl', key: 'Shipping Policy' },
    { namespace: 'mirakl', key: 'shopify_product_id' },
    { namespace: 'mirakl', key: 'Short-Description' },
    { namespace: 'mirakl', key: 'Specific-Color-Name' },
    { namespace: 'mirakl', key: 'Swatch-Image' },
    { namespace: 'mirakl', key: 'tags' },
    { namespace: 'mirakl', key: 'UPC' },
    { namespace: 'mirakl', key: 'Variant-Group-Code' },
    { namespace: 'mirakl', key: 'Variant-Type' },
    { namespace: 'mirakl', key: 'weight' }
]

export const collection_metafield_identifiers = [
    { namespace: 'custom_listing', key: 'preselected_colors' },
    { namespace: 'sale_promo', key: 'message_1' },
    { namespace: 'sale_promo', key: 'priority_1' },
    { namespace: 'sale_promo', key: 'message_2' },
    { namespace: 'sale_promo', key: 'priority_2' },
    { namespace: 'sale_promo', key: 'message_3' },
    { namespace: 'sale_promo', key: 'priority_3' },
    { namespace: 'EasyGift', key: 'EasyGift All Products' },
    { namespace: 'global', key: 'category_name' },
    { namespace: 'global', key: 'category_url' },
    { namespace: 'yoast_seo', key: 'indexable' },
    { namespace: 'global', key: 'upsell_products_title'},
    { namespace: 'global', key: 'upsell_products_enabled'}
]

export const customer_metafield_identifiers = [
    { namespace: 'social_ladder', key: 'ambassador' },
    { namespace: 'gift-reggie', key: 'shared-secret' },
    { namespace: 'peerboard', key: 'metahash' },
    { namespace: 'social_ladder', key: 'deviceUUID' }
]